import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import SampleTable from '../../components/SampleTable/SampleTable';
import './Sample.scss';

const Sample = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleCreateSample = () => {
        navigate('/samples/create');
    };

    return (
        <div className="sample-page-container">
            <CContainer>
                <div className="text-fs-head-sm text-start mb-3">{t('samples')}</div>
                <SampleTable />
            </CContainer>
            <CButton
                color="primary"
                className="create-sample-fab"
                onClick={handleCreateSample}
                title={t('createSample')}
            >
                <CIcon icon={cilPlus} size="lg" />
            </CButton>
        </div>
    );
};

export default Sample;
